// Post-mount DOM augmentation of the engine's generated markup. Ported from vouch.js.
// The scroll-world engine builds its own (non-React) DOM inside the container, so these
// helpers reach into that DOM after mount to add Vouch's brand sub-line, inject the UI
// fragments into each overlay card, wire the final CTA, and fire scene analytics.
import { FRAGMENTS } from './config';
import { DEMO_URL, track } from './analytics';

// Brand sub-line + per-card UI fragments + final CTA wiring.
export function augment(container: HTMLElement): void {
  // brand: stack a mono sub-line under the wordmark
  const nameEl = container.querySelector<HTMLElement>('.sw-brand__name');
  if (nameEl && nameEl.parentNode && !(nameEl.parentNode as HTMLElement).classList.contains('v-brandcol')) {
    const col = document.createElement('span'); col.className = 'v-brandcol';
    nameEl.parentNode.insertBefore(col, nameEl); col.appendChild(nameEl);
    const sub = document.createElement('span'); sub.className = 'v-subline';
    sub.textContent = 'TECH LOG & CAMO'; col.appendChild(sub);
  }

  // inject UI fragments into each overlay card
  const cards = container.querySelectorAll<HTMLElement>('.sw-copy');
  FRAGMENTS.forEach((html, i) => {
    if (!cards[i]) return;
    const f = document.createElement('div'); f.className = 'v-frag'; f.innerHTML = html;
    const cta = cards[i].querySelector('.sw-copy__cta');
    cards[i].insertBefore(f, cta || null);
  });

  // wire the scene-7 CTA anchors rendered by the engine
  const demoBtn = container.querySelector<HTMLAnchorElement>('.sw-copy__cta .sw-btn--primary');
  if (demoBtn) { demoBtn.setAttribute('href', DEMO_URL); demoBtn.setAttribute('data-demo', ''); }
  const bookBtn = container.querySelector<HTMLAnchorElement>('.sw-copy__cta .sw-btn--ghost');
  if (bookBtn) { bookBtn.setAttribute('href', '#book'); bookBtn.setAttribute('data-book', ''); }
}

// scene-reached analytics via the route rail's active state
export function watchScenes(container: HTMLElement): void {
  const route = container.querySelector('.sw-route');
  if (!route) return;
  const dots = Array.from(route.querySelectorAll<HTMLElement>('.sw-route__dot'));
  const seen: Record<number, number> = {};
  function fireActive() {
    dots.forEach((d, i) => {
      if (d.classList.contains('is-active') && !seen[i]) {
        seen[i] = 1; track('sw_scene_' + (i + 1) + '_reached', { scene: i + 1 });
      }
    });
  }
  const obs = new MutationObserver(fireActive);
  dots.forEach((d) => obs.observe(d, { attributes: true, attributeFilter: ['class'] }));
  fireActive(); // scene 1 is active on landing
}

// gated "Enter the demo" ghost (visible from scene 2 onward)
export function gateDemoGhost(): void {
  const ghost = document.querySelector<HTMLAnchorElement>('.v-demo-ghost');
  if (!ghost) return;
  ghost.setAttribute('href', DEMO_URL);
  let on = false;
  function upd() {
    const want = (window.scrollY || window.pageYOffset) > 0.6 * window.innerHeight;
    if (want !== on) { on = want; ghost!.classList.toggle('is-on', on); }
  }
  window.addEventListener('scroll', upd, { passive: true });
  upd();
}
